import { ENVIRONMENT } from "util/environment";
import { onlineStatus } from "../store";

const POLL_INTERVAL = 10_000; // 10 seconds

export function checkOnlineStatus() {
  fetch(`${ENVIRONMENT.API_URL}/health`, { cache: "no-store" })
    .then(() => {
      onlineStatus.isOnline = true;
      onlineStatus.lastSuccess = Date.now();
    })
    .catch(() => {
      onlineStatus.isOnline = false;
    })
    .finally(() => {
      onlineStatus.lastChecked = Date.now();
    });
}

export function startOnlineStatusPolling() {
  if (typeof window === "undefined") return;

  window.addEventListener("online", () => {
    onlineStatus.isOnline = true;
    checkOnlineStatus();
  });
  window.addEventListener("offline", () => {
    onlineStatus.isOnline = false;
  });

  setInterval(checkOnlineStatus, POLL_INTERVAL);
  checkOnlineStatus(); // Initial check
}
